import { modifierOptionSchema } from "../configs";
import ModifierOptionForm from "../forms/ModifierOption.form";
import { useCreateModifierOptionMutation, useTypedSelector } from "../store";
import { showToast, ToastType } from "../utils/toast.utils";
import { useNavigate } from "react-router-dom";

const CreateModifierOptionWrapper = () => {
  const restaurant = useTypedSelector((state) => state.session.restaurant);

  if (!restaurant)
    return (
      <div className="w-full flex justify-center mt-4 text-xl font-semibold">
        Veuillez sélectionner un restaurant
      </div>
    );

  return (
    <div className="w-full flex flex-col items-center justify-center">
      <CreateModifierOption restaurantId={restaurant._id} />
    </div>
  );
};

interface CreateModifierOptionProps {
  restaurantId: string;
}

const CreateModifierOption: React.FC<CreateModifierOptionProps> = ({
  restaurantId,
}) => {
  const [CreateModifierOption, { isLoading }] =
    useCreateModifierOptionMutation();
  const navigate = useNavigate();

  const initialValues = {
    displayName: "",
    price: undefined,
    restaurant: restaurantId,
    vatRatePercentage: undefined,
    quantityInfo: {},
    displayOrder: 1,
  };

  return (
    <div className="p-4 w-full">
      <ModifierOptionForm
        initialValues={initialValues}
        validationSchema={modifierOptionSchema}
        isLoading={isLoading}
        onSubmit={async (values, { resetForm }) => {
          const body = { ...values, price: Math.trunc(values.price * 100) };
          const result = await CreateModifierOption(body);
          if (!result.error) {
            showToast("Supplément créé", ToastType.SUCCESS);
            resetForm();
            navigate("/modifier-options");
          }
        }}
      />
    </div>
  );
};

export default CreateModifierOptionWrapper;
